// extracted by mini-css-extract-plugin
module.exports = {"sharebutton":"index-module--sharebutton--bQ-az"};